export const CY_DESKTOP_LIBRARY_BUTTON = 'ds-l'
export const CY_DESKTOP_SEARCH_BUTTON = 'ds-s'
export const CY_DESKTOP_PARAPHRASER_BUTTON = 'ds-p'
export const CY_DESKTOP_TOUR_SEARCH = 'dt-s'
export const CY_DESKTOP_TOUR_NEXT = 'dt-n'
export const CY_DESKTOP_TOUR_PREV = 'dt-p'
export const CY_DESKTOP_TOUR_LOGIN = 'dt-l'
export const CY_DESKTOP_TRANSLATE_BUTTON = 'ds-t'
